import { configureStore } from '@reduxjs/toolkit';
import taskReducer from './slice/taskSlice';
import rawDataReducer from "./slice/rawdataSlice";
import jobApplicationReducer from "./slice/jobApplicationSlice";

export const store = configureStore({
  reducer: {
    tasks: taskReducer,
    rawData: rawDataReducer,
    jobApplications: jobApplicationReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;